export type BuiltInCourseExecutionTextFieldKey = 'version';

export const BUILTIN_COURSE_EXECUTION_TEXT_FIELDS: Record<
    BuiltInCourseExecutionTextFieldKey,
    { id: string; attributeName: string; translationKey: string }
> = {
    version: {
        id: 'version',
        attributeName: 'version',
        translationKey: 'GENERAL.PROPERTY.VERSION',
    },
};
